import React from "react";

import Modal from "@mui/material/Modal";
import {Close} from "@vedmarket/ui-kit";

import CallToActionImage from "./CallToActionImage";

import styles from "./CallToActionModal.module.scss";
import {translatePartnerText} from '../../locales/language';

type CallToActionModalProps = {
    open: boolean;
    handleClose: () => void;
};

function CallToActionModal({open, handleClose}: CallToActionModalProps) {
    const handleClickImage = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <div className={styles.modal} onClick={handleClose}>
                <button className={styles.closeButton} onClick={handleClose} type="button" aria-label={translatePartnerText('Close')}>
                    <Close/>
                </button>
                <div className={styles.imageContainer} onClick={handleClickImage}>
                    <CallToActionImage
                        className={styles.image}
                        loading="eager"
                        sizes="(max-width: 767px) 96vw, (max-width: 1224px) 98vw, 1200px"
                    />
                </div>
            </div>
        </Modal>
    );
}

export default CallToActionModal;
